import { render } from "./RegisterDevicePopup.vue?vue&type=template&id=70cc7bd4&ts=true"
import script from "./RegisterDevicePopup.vue?vue&type=script&lang=ts"
export * from "./RegisterDevicePopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__